<template>
  <div v-if="!isActive" class="header_menu">
    <div v-for="item in menuOptions" :key="item.label" class="menu-item">
      <div class="menu-content" :class="{ menu_content_select: activeKey === item.key }" @click="mainRoute(item)">
        {{ item.label }}

        <div v-if="item.icon === 'new'" class="menu-tips"></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import { useRouterHook } from '@/hooks/useRouter';
defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
});
const route = useRoute();

const { goto } = useRouterHook();
const store = useStore();

const menuOptions = computed(() => store.state.user.menuOptions);

const activeKey = computed(() => {
  return route.meta.ownType || 'Home';
});

const mainRoute = (item: any) => {
  const { name } = item;
  goto({
    name,
  });
};
</script>
<style lang="scss">
.header_menu {
  display: flex;
  height: 100%;
  // align-items: center;
}

.menu-item {
  padding: 0 22px;
}

.menu-content {
  font-size: 16px;
  color: #7c7c7c;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  &:hover {
    font-weight: bold;
    color: #572df3;
  }

  &::after {
    content: '';
    position: absolute;
    width: 0;
    bottom: 0;
    left: 0;
    height: 3px;
  }
}

.menu-tips {
  position: absolute;
  color: red;
  // font-size: 10px;
  right: -29px;
  top: 10px;
  font-weight: bold;
  width: 30px;
  height: 19px;
  background-image: url('@/assets/new_icon1.png');
  background-size: contain;
  background-repeat: no-repeat;
}
.menu_content_select {
  font-weight: bold;
  color: #262626;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    border-radius: 1px;
    background-color: #572df3;
    bottom: 0;
    left: 0;
    transition: width 0.2s;
  }
}
</style>
